import React, {useState} from 'react';
import * as anchor from "@project-serum/anchor";
import classes from "./VsScreen.module.css";
import {playerA, playerB} from "../../dummyData/data";
import ScoreBoardA from './vsScreen/ScoreBoardA';
import ScoreBoardB from './vsScreen/ScoreBoardB';
import SmallMeshA from './vsScreen/SmallMeshA';
import SmallMeshB from './vsScreen/SmallMeshB';
import BigMeshA from './vsScreen/BigMeshA';
import BigMeshB from './vsScreen/BigMeshB';
import EndGameComponent from './UI/EndGameComponent';
import NavBar from '../partials/NavBar';
import { useEffect, useMemo } from 'react';
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletWallet,
  getSolletExtensionWallet,
} from "@solana/wallet-adapter-wallets";
import { ThemeProvider, createTheme } from '@material-ui/core';
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import {useLocation, useParams} from "react-router-dom"
import { useWallet } from '@solana/wallet-adapter-react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AWS from "aws-sdk";
import GameModal from './UI/GameModal';

const configuration = {
  region: 'us-east-1',
  secretAccessKey: 'pbB5rUOe7+2ECT1fiDMQYp0DA0PJWPRFtejv92Ag',
  accessKeyId: 'AKIAWENPZQUFICV7X77K'
}

interface NavProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}

interface endGameProps {
    open: boolean; 
    win: boolean;
}

const theme = createTheme({
  palette: {
    type: "dark",
  },
});

interface modalProps {
  show: boolean;
  title?: string;
  body?: string;
  onClickNo?: () => void;
  onClickYes?: () => void;
}

AWS.config.update(configuration)
var ddb = new AWS.DynamoDB.DocumentClient();

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const VsScreen = (props: NavProps) => {
  const location = useLocation();

  const endpoint = useMemo(() => clusterApiUrl(network), []);
  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSlopeWallet(),
      getSolflareWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    []
  );


  const [endGame, setEndGame] = useState<endGameProps>({
      open: false,
      win: false
  })

  const playAgainHandler = () => {
    setEndGame({
        open: false,
        win: false
    })
  }

  const attackBtnHandler = () => {
    combat('attack')
  }
  const defendBtnHandler = () => {
    combat('defend')
  }
  const evadeBtnHandler = () => {
    combat('evade')  
  }

  class Mech {
    name: string;
    imageUrl: string;
    claimed: boolean;
    strength: number;
    agility: number;
    durability: number;
    efficiency: number;
    pilotSkills: number;
    
    constructor(
      name: string, 
      imageUrl: string, 
      claimed: boolean, 
      strength: number, 
      agility: number, 
      durability: number,
      efficiency: number, 
      pilotSkills: number) {

      this.name = name;
      this.imageUrl = imageUrl;
      this.claimed = claimed;
      this.strength = strength;
      this.agility = agility;
      this.durability = durability;
      this.efficiency = efficiency;
      this.pilotSkills = pilotSkills;
    }
  }

  class SpaceKitty {
    name: string;
    imageUrl: string;
    constructor(name: string, imageUrl: string) {
      this.name = name;
      this.imageUrl = imageUrl;
    }
  }

  // @ts-ignore
  const [address, setAddress] = useState<string>(location.state.address);
  // @ts-ignore
  const [heroMech, setHeroMech] = useState<Mech>(new Mech(location.state.mechName, location.state.imageUrl, true, location.state.strength, location.state.agility, location.state.durability, location.state.efficiency, location.state.pilotSkills));
  // @ts-ignore
  const [pilot, setPilot] = useState<SpaceKitty>(new SpaceKitty(location.state.kittyName, location.state.spaceKittyUrl));
  const [villainMech, setVillainMech] = useState<Mech>();
  const [heroHealth, setHeroHealth] = useState<number>(80);
  const [heroShield, setHeroShield] = useState<number>(0);
  const [heroGas, setHeroGas] = useState<number>(80);
  const [heroMechVar, setHeroMechVar] = useState<number>(90);
  const [heroRankVar, setHeroRankVar] = useState<number>(20);
  const [villainHealth, setVillainHealth] = useState<number>(80);
  const [villainShield, setVillainShield] = useState<number>(0);
  const [villainGas, setVillainGas] = useState<number>(80);
  const [villainMechVar, setVillainMechVar] = useState<number>(70);
  const [villainRankVar, setVillainRankVar] = useState<number>(30);
  const wallet = useWallet();
  const [isMatchActive, setIsMatchActive] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<modalProps>({
    show: false,
    title: "",
    body: "",
  });


  function getRandomInt(max: number) {
    return Math.floor(Math.random() * max) + 1;
  }

  function getRandomArbitrary(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  const attack = function(strength: number) {
    return Math.floor(getRandomArbitrary(.75, 1) * strength);
  }

  const defend = function(heroDurability: number, villainStrength: number) {
    return getRandomInt(heroDurability) > getRandomInt(villainStrength);
  }

  const evade = function(heroAgility: number, villainAgility: number) {
    return getRandomInt(heroAgility) > getRandomInt(villainAgility);
  }

  const gas = function(efficiency: number) {
    return Math.floor((getRandomInt(40) + 20) / efficiency);
  }

  const write = async function(write_params: any) {
    ddb.put(write_params, function(err, data) {
      if (err) {
        console.log("Error", err);
      } else {
        console.log("Success", data);
      }
    });
  }

  const recordMatch = async function(name: any, villain: any, won: boolean) {
    if (wallet && wallet.publicKey && name != null && villain != null) {
      var params = {
        TableName: 'match-history',
        Item: {
          address : wallet.publicKey.toBase58(),
          timestamp: Date.now(),
          mech: name,
          villain: villain,
          won: won
        }
      }
      write(params);
    }
  }
  
  const getOpponent = async function(myMech: String) {
    const params = {
      TableName: 'mech-metadata',
    };
    const items = await ddb.scan(params).promise();
    const mech = shuffle(items.Items?.filter(item => item.name !== myMech && item.claimed !== false)).pop();
    return new Mech(mech.name, mech.imageUrl, mech.claimed, mech.strength, mech.agility, mech.durability, mech.efficiency, mech.pilot_skills);
  }

  const shuffle = function(array: any) {
    let currentIndex = array.length,  randomIndex;
  
    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
    return array;
  }

  const initiate = async function() {
    console.log(heroMech);
    if (!isMatchActive && heroMech) {
      const mech2 = await getOpponent(heroMech.name);
      setVillainMech(mech2);
      setHeroShield(heroMech.durability * 4);
      setVillainShield(mech2.durability * 4);
      setIsMatchActive(true);
    }
  }

  const inflictDamage = function(damage: number, target: String) {
    console.log(damage);
    if (target === 'hero') {
      if (damage <= heroShield) {
        setHeroShield(heroShield - damage);
       } else {
        const remainder = heroHealth - (damage - heroShield);
        setHeroHealth(remainder);
        setHeroShield(0);
      }
    } else {
      if (damage <= villainShield) {
        setVillainShield(villainShield - damage);
       } else {
        const remainder = villainHealth - (damage - villainShield);
        setVillainHealth(remainder);
        setVillainShield(0);
      }
    }
  }

  const combat = function(heroMove: String) {
     let villainMove = '';
     if (heroGas === 0) {
      villainMove = 'attack';
     } else {
      villainMove = shuffle(['attack', 'defend', 'defend', 'evade']).pop();
     } 
     
     if (!heroMech || !villainMech || !isMatchActive) return;

     let result = '';
     let heroCrit = 1;
     let villainCrit = 1;

     if (villainGas === 0) {
       heroCrit = Math.ceil((heroMech.pilotSkills / 5) * getRandomArbitrary(.8, 1.2));
     }
     if (heroGas === 0) {
       villainCrit = Math.ceil((villainMech.pilotSkills / 5) * getRandomArbitrary(.8, 1.2));
     }
     const heroDamage = attack(heroMech.strength) * heroCrit;
     const villainDamage = attack(villainMech.strength) * villainCrit;

     if (heroMove === 'attack' && villainMove === 'attack') {
       inflictDamage(heroDamage, 'villain')
       inflictDamage(villainDamage, 'hero')
       result = heroMech.name + ' inflicts ' + heroDamage + ' damage and takes ' + villainDamage + ' damage!';
     } else if (heroMove === 'attack' && villainMove === 'defend') {
       if (defend(villainMech.durability, heroMech.strength)) {
        result = "Your attack was blocked by " + villainMech.name + '!'
       } else {
        inflictDamage(heroDamage, 'villain');
        result = heroMech.name + ' inflicts ' + heroDamage + " damage through the enemy's defense!";
       }
     } else if (heroMove === 'attack' && villainMove === 'evade') {
       if (evade(villainMech.agility, heroMech.agility)) {
        result = "Your attack was evaded by " + villainMech.name;
       } else {
        inflictDamage(heroDamage, 'villain');
        result = 'Your attack succeeds despite ' + villainMech.name + "'s evasive manuever, inflicting " + heroDamage + ' damage!';
       }
     } else if (heroMove === 'defend' && villainMove === 'attack') {
      if (defend(heroMech.durability, villainMech.strength)) {
        result = "You blocked the attack by " + villainMech.name + '!'
      } else {
       inflictDamage(villainDamage, 'hero');
       result = villainMech.name + ' inflicts ' + villainDamage + " damage through your defense!";
      }
     } else if (heroMove === 'evade' && villainMove === 'attack') {
      if (evade(heroMech.agility, villainMech.agility)) {
        result = "You evaded the attack by " + villainMech.name;
       } else {
        inflictDamage(villainDamage, 'hero');
        result = villainMech.name + "'s attack succeeds despite " + "your evasive manuever, inflicting " + villainDamage + ' damage!';
       }
     } else {
       result = "Nothing happened!"
     }

     console.log(result);
     notify(result);
     setShowModal({
      show: true,
      title: "",
      body: result,
      // onClickYes: () => {
      //   setShowModal({ show: false })
      // },
      // onClickNo: () => {
      //    //action to do on NO click
      //   setShowModal({ show: false })
        
      // }
     });
        setTimeout(() => {
          setShowModal({ show: false })
        }, 3000);
    
     //Calculate gas cost
     let heroGasSpent = gas(heroMech.efficiency);
     let villainGasSpent = gas(villainMech.efficiency);

     if (heroMove === 'attack') {
      heroGasSpent = heroGasSpent * 3;
     }
     if (villainMove === 'attack') {
      villainGasSpent = villainGasSpent * 3;
     }
     setHeroGas(heroGas - heroGasSpent > 0 ? heroGas - heroGasSpent : 0)
     setVillainGas(villainGas - villainGasSpent > 0 ? villainGas - villainGasSpent : 0)
  }
  
  const notify = (message: String) => toast(message);

  window.onbeforeunload = (e) => {
    if (isMatchActive && heroMech) {
      console.log('Automatic Loss');
      recordMatch(heroMech?.name, villainMech?.name, false);
    }
    e.preventDefault()
    e.returnValue = '';
  };

  const refreshState = () => {
    (async () => {
      console.log(heroMech);
      console.log(pilot);
      console.log("SHIELD: " + heroShield);
      console.log("HEALTH: " + heroHealth);
      console.log("GAS: " + heroGas);
      console.log(villainMech);
      console.log("SHIELD: " + villainShield);
      console.log("HEALTH: " + villainHealth);
      console.log("GAS: " + villainGas);
      if (!wallet || !heroMech || !isMatchActive) return
      if (heroHealth <= 0 && villainHealth <= 0) {
        if (heroHealth < villainHealth) {
          notify("You were defeated!")
          setEndGame({
            open: true,
            win: false
          })
          recordMatch(heroMech.name, villainMech?.name, false);
        } else {
          setEndGame({
            open: true,
            win: true
          })
          recordMatch(heroMech.name, villainMech?.name, true);
        }
        setIsMatchActive(false);
      } else if (heroHealth <= 0) {
        setEndGame({
          open: true,
          win: false
        })
        recordMatch(heroMech.name, villainMech?.name, false);
        setIsMatchActive(false);
      } else if (villainHealth <= 0) {
        setEndGame({
          open: true,
          win: true
        })
        recordMatch(heroMech.name, villainMech?.name, true);
        setIsMatchActive(false);
      }
    })();
  };

  useEffect(refreshState, [
    heroHealth,
    heroShield,
    heroGas,
    villainHealth,
    villainShield,
    villainGas,
    heroMech,
  ]);

  useEffect(() => {
    // setHeroMech(new Mech("#1", 'url', true, 12, 12, 12, 12, 12));
    initiate();
  }, [])
  return (
      
      <ThemeProvider theme={theme}>
          <ConnectionProvider endpoint={endpoint}>
              <WalletProvider wallets={wallets} autoConnect={true}>
                  <WalletDialogProvider>
                      <div className={classes["stat-screen-root"]}>
                          {showModal.show &&
                            <GameModal
                            title={showModal.title}
                            body={showModal.body}
                            // onClickYes={showModal.onClickYes!}
                            // onClickNo={showModal.onClickNo!}
                            />}
                          <div className={classes["small-device"]} > Please Play game from a Large Screen </div>
                          {endGame.open && <EndGameComponent playAgainBtn={playAgainHandler} win={endGame.win} />}
                          <div className={classes["stat-screen-frame"]}>
                              <div data-aos="fade-left" className={classes["player-a-root"]}>
                                  <ScoreBoardA
                                      shield={heroShield}
                                      hp={heroHealth}
                                      gas={heroGas}
                                      mechVar={heroMechVar}
                                      rankVar={heroRankVar}
                                  />
                                  <SmallMeshA img={pilot.imageUrl} />
                                  <BigMeshA img={heroMech.imageUrl} />
                              </div>
                              <div data-aos="fade-right" className={classes["player-b-root"]}>
                                  <BigMeshB img={villainMech != null ? villainMech.imageUrl : playerB.mainImg} />
                                  <SmallMeshB img={playerB.imgPrev} />
                                  <ScoreBoardB
                                      shield={villainShield}
                                      hp={villainHealth}
                                      gas={villainGas}
                                      mechVar={villainMechVar}
                                      rankVar={villainRankVar}
                                  />
                                  <div className={classes["btn-root"]}>
                                      <img onClick={() => {
                                          attackBtnHandler()
                                      }} src="https://space-kitties.vercel.app/attackBtn.png" alt="game btn" />
                                      <img onClick={() => {
                                          defendBtnHandler()
                                      }} src="https://space-kitties.vercel.app/defendBtn.png" alt="game btn" />

                                      <img onClick={() => {
                                          evadeBtnHandler()
                                      }} src="https://space-kitties.vercel.app/evadeBtn.png" alt="game btn" />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </WalletDialogProvider>
              </WalletProvider>
          </ConnectionProvider>
      </ThemeProvider>
    )
}

export default VsScreen